/*
 * Globals expected by older inline scripts and jQuery plugins throughout
 * the survey Blade views. These were `window._ = require('lodash')` and
 * `window.axios = require('axios')` under Mix; Vite needs ESM imports.
 */

import _ from 'lodash';
import axios from 'axios';

window._ = _;
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
